export default {
      id: "infotool-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#infotool",
      toString: function () {
        return this.url;
      }
    }